var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.5 8C6.94688 8 7.32956 7.8432 7.64806 7.5296C7.96602 7.21653 8.125 6.84 8.125 6.4C8.125 5.96 7.96602 5.5832 7.64806 5.2696C7.32956 4.95653 6.94688 4.8 6.5 4.8C6.05312 4.8 5.67071 4.95653 5.35275 5.2696C5.03425 5.5832 4.875 5.96 4.875 6.4C4.875 6.84 5.03425 7.21653 5.35275 7.5296C5.67071 7.8432 6.05312 8 6.5 8ZM6.5 16C4.31979 14.1733 2.69154 12.4765 1.61525 10.9096C0.538417 9.3432 0 7.89333 0 6.56C0 4.56 0.653521 2.96667 1.96056 1.78C3.26706 0.593333 4.78021 0 6.5 0C8.21979 0 9.73294 0.593333 11.0394 1.78C12.3465 2.96667 13 4.56 13 6.56C13 7.89333 12.4619 9.3432 11.3856 10.9096C10.3087 12.4765 8.68021 14.1733 6.5 16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.b8a5993dffb4348dcd9a38a5e7b098b4.svg";
export { ForwardRef as ReactComponent };